import { useSelector } from "react-redux";
import useUserColumns from "./Hooks/useUserColumns";
import { useEffect, useState } from "react";
import {
  getFilteredDataWithTabs,
  getListingByOrgId,
} from "../../../../Utils/CommonService";
import TableWrapper from "../../../../Components/Common/Tables/Tanstack/components/TableWrapper";
import CommonHeader from "../../../../Components/Common/CommonHeader/CommonHeader";
import NewUsersModal from "./NewUserModal";
import { getAllRoles, getRoles } from "./UserService";
import {
  btnAccessChecker,
  checkAccessPermission,
  checkButtonAccess,
  commonAccessChecker,
  getEntityType,
  getOrgId,
  getOrgType,
  getOrganizationId,
  getOrganizationType,
} from "../../../../Utils/CommonUtils";
import UserFilter from "./UserFilter";
import {
  setUserFilterForm,
  setUsersData,
} from "../../../../slices/team/users/usersSlice";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { resetFormState, setOrgId } from "../../../../slices/common/reducer";
import { setUserSorting } from "../../../../slices/team/users/usersSlice";

const UsersList = () => {
  const dispatch = useDispatch();
  const { usersColumns } = useUserColumns();

  const usersData = useSelector((state) => state.users.usersData);
  const rolesData = useSelector((state) => state.users.rolesData);
  const usersFieldJson = useSelector((state) => state.users.usersFieldJson);
  const triggerRender = useSelector((state) => state.common.triggerRender);
  const modalShow = useSelector((state) => state.common.modalShow);
  const totalRows = useSelector((state) => state.common.pagination.totalCount);
  const editShow = useSelector((state) => state.common.editShow);
  const apiTabData = useSelector((state) => state.common.pagination.tabs);
  const selector = useSelector((state) => state.moduleaccesstree);
  const filterApi = useSelector((state) => state.users.filter.filterApi);
  const filterForm = useSelector((state) => state.users.filter.form);
  const sortColumn = useSelector((state) => state.order.sorting.column);
  const sortOrder = useSelector((state) => state.order.sorting.order);
  const selectedUser = useSelector((state) => state.header.selectedUser);
  const organizationId = selectedUser.organizationid;
  const enterpriseid = localStorage.getItem("enterpriseid");
  const entityType = getEntityType();

  useEffect(() => {
    if ((selectedUser.entitytype, organizationId)) {
      getRoles(selectedUser.entitytype, organizationId, usersFieldJson);
    }
    dispatch(resetFormState());
  }, [selectedUser.entitytype, organizationId, triggerRender]);

  useEffect(() => {
    dispatch(setUserFilterForm({ type: "reset" }));
  }, []);

  return (
    <div>
      <CommonHeader
        title={"All Users"}
        newButton={true}
        checkAccessCreate={checkButtonAccess("CREATE", "TEM_USR")}
        deletebtn={true}
        buttonTitle={"New User"}
        filterComponent={<UserFilter />}
        dash={true}
      />
      <div>
        <TableWrapper
          columns={usersColumns}
          data={usersData}
          apiTabData={apiTabData}
          paginatedApi
          filterApi={filterApi}
          filterApiEntity={"AGSU"}
          filterApiListEntity={"AGSU"}
          filterApiFunction={setUsersData}
          filterApiService={getFilteredDataWithTabs}
          filterForm={filterForm}
          totalRows={totalRows}
          status={"ALL"}
          statusColumn={"status"}
          hideTabsWrapper={true}
          serverSort
          serverSortColumn={sortColumn}
          serverSortOrder={sortOrder}
          serverSortState={setUserSorting}
          organizationIdUser={organizationId}
          enterpriseId={enterpriseid}
          organizationId={organizationId}
        />
      </div>
      {(modalShow || editShow) && <NewUsersModal rolesData={rolesData} />}
    </div>
  );
};

export default UsersList;
